"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  pmiChangeCancel: 'Cancel',
  pmiChangeConfirmed: 'Change',
  pmiChangeConfirmTitle: 'Change Personal Meeting settings?',
  pmiChangeConfirmContext: "Changing these settings will affect all meetings that use your personal meeting ID or name, including those you've already scheduled"
};
exports["default"] = _default;
//# sourceMappingURL=en-US.js.map
